import Page from "@app/components/pageTypes/Page/Page"
import { useState } from "react"
import Page1 from "./Page1"
import Page2 from "./Page2"
import Page3 from "./Page3"

export default function OnSiteLoungerBookingPage() {
	const [step, setStep] = useState(1)
	//TODO ADD LOCK BUTTON -> ENABLE LOCK WHILE LOCK SCHOW SCREEN ONLY ON LOGIN REMOVE LOCK

	return (
		<Page style={{ backgroundColor: "#efefef" }} className="p-4">
			<div className="boxShadow h-100 flex flex-column color-bg-default">
				{step === 1 && <Page1 onNext={() => setStep(2)} />}
				{step === 2 && <Page2 onNext={() => setStep(3)} onBack={() => setStep(1)} />}
				{step === 3 && <Page3 onNext={() => setStep(1)} onBack={() => setStep(2)} />}
			</div>
		</Page>
	)
}
